//module d'interface avec la blockchain

import { delay } from "lodash";
import {DEBUG} from "./utilitaires";

var instance, accounts;
export var accountFournisseur = "";
// export var fournisseurEstAutorise = fournisseurAutorise(accountFournisseur)
export var fournisseurEstAutorise = false


//fournisseurs
export async function creerFournisseur(
  _nomF,
  _identF,
  _adresseP,
  _paysF,
  _compteF
) {
  try {
    if (DEBUG) console.log("je vais appeler creerFournisseur dans intchaine");
    var numF = await instance.methods
      .createFournisseur(_nomF, _identF, _adresseP, _paysF, _compteF)
      .send({
        from: accountFournisseur, // accounts[0],
        gasPrice: 0,
        gas: 25000000
        // maxPriorityFeePerGas: null,
        // maxFeePerGas: null,
      });
  } catch (e) {
    if (DEBUG) console.log("erreur dans creerFournisseur dans intchaine")
    throw e;
  }
  return numF;
}

export async function getLengthFournisseurs() {
  return await instance.methods.getLengthFournisseurs().call();
}

export async function getIdFournisseurParAdresse(addrF) {
  return await instance.methods.getIdFournisseurParAdresse(addrF).call();
  // return await (()=> 0)
}

export async function getInfosFournisseur(numF) {
  let res = await instance.methods.getInfosFournisseur(numF).call();
  return res;
}

export async function getDernierLotFournisseur(numF) {
  let res = await instance.methods.getDernierLotFournisseur(numF).call(); 
  return res;
}

export async function getNomFournisseurParNumF(numF) {
    let res = await instance.methods.getNomFournisseur(numF).call();
    return res
  }

export async function getNomFournisseur(addrF) {
  if (!addrF) {
    return "XXX"
  }
  else {
    let numF = await instance.methods.getIdFournisseurParAdresse(addrF).call();
    let res = await instance.methods.getNomFournisseur(numF).call();
    if (DEBUG) console.log("dans recopier getNomfournisseur, le nom: ", res)
    return res
  }
}

export async function getAutoriseFournisseur(accountFournisseur) { // pas utilisé
  if (!accountFournisseur) {
    return false
  }
  let autorise = await instance.methods.getAutoriseFournisseur(accountFournisseur).call();
  if (DEBUG) console.log("dans intchaine, autorisefournisseur: ", autorise)
  // return autorise
  return autorise
}


export async function typeLot(numL) {
  let res = await instance.methods.typeLot(numL).call();
  return res;
}

export async function existeLot(numL) {
  let res = await instance.methods.existeLot(numL).call();
  return res;
}

export async function verifierLotFournisseur(numL) {
  //return true
  let res = await instance.methods.verifierLotFournisseur(accountFournisseur,numL).call();
  return res;
}

export async function setRappelLot(numL,rappel) {
  //return true;
  try {
  var res = await instance.methods.setRappelLot(numL, rappel)
  .send({
    from: accountFournisseur, // accounts[0],
    gasPrice: 0,
    gas: 25000000
    // maxPriorityFeePerGas: null,
    // maxFeePerGas: null,
  });
  } catch (e) {
    if (DEBUG) console.log("erreur dans setRappelLot dans intchaine")
    throw e;
  }
  return res;
 }


// export async function setRappelLot(numL,rappel) {
//   //return true;
//   let res = await instance.methods.setRappelLot(numL, rappel).call();
//   return res;
//  }

 export async function getRappelLot(numL) {
  //return true;
  let res = await instance.methods.getRappelLot(numL).call();
  return res;
 }


export async function simulerClassement(note, categorie) {
  let res = await instance.methods.simulerClassement(note, categorie).call();
  return res;
}

export async function getInfosCarbone(numL) {
  let res = await instance.methods.getCarboneTotEtCarbonePertLot(numL).call();
  return res;
}

export async function getLotsFils(numL) {
  let res = await instance.methods.getLotsFils(numL).call(); //attention changer le nom de cette fonction dans le contrat...
  return res;
}

//Lots
export async function creerLotEtSousLots(
  _nomL,
  _libelle,
  _hashIm,
  _descrLot,
  _argL,
  _lotsFils,
  _pourcentL,
  _idF,
  _note,
  _classement,
  _catL,
  _pourcentExtL,
  _carbone,
  _carboneTotal,
  _carbonePertinent,
  _carboneRajoute,
  _DLC,  
  _lesSousLotsCarbone,
  _lesSousLotsCarbonePertinent,
  _lesSousLotsCarbRajoute,
  _lesSousLotsNumFourn,
  _lesSousLotsLibelleFourn,
  _lesSousLotsNomFabs,
  _lesSousLotsPaysFabs,
  _lesSousLotsDescrFourn,
  _lesSousLotsPourcentsFourn
  // _lesSousLotsDescrFourn
) {
  try {
  var numL = await instance.methods
    .createLotEtSousLots(
      _nomL,
      _libelle,
      _hashIm,
      _descrLot,
      _argL,
      _lotsFils,
      _pourcentL,
      _idF,
      _note,
      _classement,
      _catL,
      _pourcentExtL,
      _carbone,
      _carboneTotal,
      _carbonePertinent,
      _carboneRajoute,
      _DLC,
      _lesSousLotsCarbone,
      _lesSousLotsCarbonePertinent,
      _lesSousLotsCarbRajoute,      
      _lesSousLotsNumFourn,
      _lesSousLotsLibelleFourn,
      _lesSousLotsNomFabs,
      _lesSousLotsPaysFabs,
      _lesSousLotsDescrFourn,
      _lesSousLotsPourcentsFourn
      // _lesSousLotsDescrFourn
    )
    .send({
      from: accounts[0],
      gasPrice: 0,
      gas: 25000000,
      maxPriorityFeePerGas: null,
      maxFeePerGas: null,
    });
  } catch(e) {
    if (DEBUG) console.log("problème au niveau de la chaine dans createLotetsouslots");
    throw e
  }
  if (DEBUG) console.log("terminé dans interface chaine fonction creerLotEtSousLots et numL=", numL);
  // return numL;
}

export async function getInfosLot(numL) {
  var infosLot1 = await instance.methods.getInfosLot1(numL).call();
  const { 0: typeLot, 1: nomLot, 2: libelle, 3: hashIm, 4: descrL, 5: argum } = infosLot1;
  var infosLot2 = await instance.methods.getInfosLot2(numL).call();
  const { 0: lotsFi, 1: pourcentL, 2: lotsP, 3: idF, 4: dateL, 5: noteL, 6: classementL, 7: fabL, 8: catL, 9: paysL, 10: pourcentExtL,
    11: carbone, 12: carboneTot, 13: carbonePert, 14: carboneRaj, 15: DLC, 16: rappel } = infosLot2;
  // console.log("Dans interface chaine, infosLot2, lot et rappel = ", numL, DLC);  
  // console.log("Dans interface chaine, infosLot2, lot et rappel = ", numL, rappel);  

  let d = new Date(dateL * 1000);
  let mois = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
  let dateFormat =
      // d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
      d.getDate() + " " + (mois[d.getMonth()]) + " " + d.getFullYear();
  return {
    0: typeLot,
    1: nomLot,
    2: libelle,
    3: hashIm,
    4: descrL,
    5: argum,
    6: lotsFi,
    7: pourcentL,
    8: lotsP,
    9: idF,
    10: dateFormat,
    11: noteL,
    12: classementL,
    13: fabL,
    14: catL,
    15: paysL,
    16: pourcentExtL,
    17: carbone,
    18: carboneTot,
    19: carbonePert,
    20: carboneRaj,
    21: DLC,
    22: rappel
  };
}

export async function getLengthLots() {
  if (DEBUG) console.log("de getLengthLots");
  return await instance.methods.getLengthLots().call();
}

window.ethereum.on("chainChanged", async (chainId) => {
  /* handle the chainId */
  if (DEBUG) console.log("Network changed!!");
  await window.location.reload();
  fournisseurEstAutorise = getAutoriseFournisseur(accountFournisseur)
});

window.ethereum.on("accountsChanged", async function (accounts) {
  // Time to reload your interface with accounts[0]!
  if (DEBUG) console.log("Account changed!!");
  window.location.reload();
  fournisseurEstAutorise = getAutoriseFournisseur(accountFournisseur)
});

window.ethereum.on("disconnect", function () {
  // Time to reload your interface with accounts[0]!
  alert("Accès à la chaîne impossible");
  // window.location.reload();
});


export async function lancer() {
  const Web3 = require("web3");
  if (DEBUG) console.log("ai chargé Web3");

  var provider = window.ethereum;
  const web3 = new Web3(provider);
  if (DEBUG) console.log("ai chargé provider");

  const contractArtifact = require("./ContratTraceur.json"); //produced by Truffle compile
  if (DEBUG) console.log("ai appelé contratTraceur");
  
  
  // selon chatGPT...
  //------------------------------------------------
  const chainId = await window.ethereum.request({
    method: "eth_chainId"
});
const numero_reseau = parseInt(chainId, 16);
console.log("Network ID:", numero_reseau);
  //-----------------------------------
  

  
   // au lieu de ....
  //const numero_reseau = await web3.eth.net.getId();
  //if (DEBUG) console.log("numero de reseau: ", numero_reseau);
  
  
  
  const abi = contractArtifact.abi;
  const addr = contractArtifact.networks[numero_reseau].address;

  instance = new web3.eth.Contract(abi, addr);
  if (DEBUG) console.log("ai créé instance");

  await window.ethereum.request({ method: 'eth_requestAccounts' }); //POUR PROBLEMES DE CONNEXION METAMASK 

  accounts = await web3.eth.getAccounts();
  accountFournisseur = accounts[0]; 
  fournisseurEstAutorise = await getAutoriseFournisseur(accountFournisseur)
  if (DEBUG) console.log("accounts: ", accounts);
  if (DEBUG) console.log("accountFournisseur: ", accountFournisseur);

  let nbrF = await getLengthFournisseurs();
  if (DEBUG) console.log("nbre de fournisseurs dans intchaine:", nbrF);

  let nbrL = await getLengthLots();
  if (DEBUG) console.log("nbre de lots dans intchaine:", nbrL);
  console.log("Connexion blockchain OK")

} // fin lancer

